<template>
	<div class="sy-ch-main container-fluid text-center">
		<!-- EDIT -->
		<table align="center" style="text-align:left;margin:auto;" class="container400" v-on:keyup.enter = "editSubmit" v-if = "editing">
			<tbody>
				<tr>
					<td>
						<button class="btn" @click = "cancel" >Cancel</button>
						<button class="btn" @click = "editSubmit" >Update</button>
					</td>
				</tr>
				<tr>
					<td>
						<div class="form_control">
							<label for="OldEmail">Old Email</label>
							<input id= "OldEmail" readonly type = "email" placeholder = "example@email.com" v-model.trim = " editForm['Old Email']">
							<p class = "font-red">{{ errorMsg['Old Email']}}</p>
						</div>

					</td>
				</tr>
				<tr>
					<td>
						<div class="form_control">
							<label for="NewEmail">New Email</label>
							<input id= "NewEmail"  type = "email" placeholder = "example@email.com" v-model.trim = " editForm['New Email']">
							<p class = "font-red">{{ errorMsg['New Email']}}</p>
						</div>

					</td>
				</tr>
				<tr>
					<td>
						<div class="form_control">
							<label for="Password">Password</label>
							<input id= "Password"  type = "password" placeholder = "******" v-model.trim = " editForm['Password']">
							<p class = "font-red">{{ errorMsg['Password']}}</p>
						</div>

					</td>
				</tr>
			</tbody>
		</table>


		<!-- VIEW -->
		<table align="center" style="text-align:left;margin:auto;" class="container400" v-else>
			<tbody>
				<tr>
					<td>
						<div class="form_control">
							<label for="input-email">Current Email</label>
							{{email}}
						</div>
						<div class="form_control">
							<button class="btn" @click = "editStart(oriItem)">Update Email</button>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
var md5 = require('md5');
var uuid = require('uuid/v5');
var itemTemplate;
var dbPath, docID;
export default {
	//==============================================//
	//												//
	//					DATA						//
	//												//
	//==============================================//
	data(){
		itemTemplate = [{"Name":"Old Email","checkFun":"email","children":[],"defaultValue":"","inputType":"email","manyView":true,"max":"","min":"","placeholder":"example@email.com","singleView":true,"type":"Email"},{"Name":"Password","checkFun":"text","children":[],"defaultValue":"","inputType":"password","manyView":true,"max":"","min":"","placeholder":"Password","singleView":true,"type":"Password"},{"Name":"New Email","checkFun":"email","children":[],"defaultValue":"","inputType":"email","manyView":true,"max":"","min":"","placeholder":"example@email.com","singleView":true,"type":"Email"}];

		dbPath = "business/" + this.$route.params.businessID + "/admins";
		docID = myFB.auth.currentUser.uid;
		return{
			// FORM
			editForm: {},
			errorMsg: {},

			// NAV VARIABLES
			editing: false,
			email: myFB.auth.currentUser.email,
		}
	},
	//==============================================//
	//												//
	//					METHODS						//
	//												//
	//==============================================//
	methods:{
		//------------------------------ FORMAT ------------------------------//
		formatDate(input){
			var mode = {
				separator: " ",
				sequence: "ddmmyyyy",
				monthMode: 1,
				showDate: 1,
				showMonth: 1,
				showYear: 1,
			}
			return myDate.displayDate(input, mode);
		},
		formatPrice(input, prefix){
			var prefix = prefix || "";
			return myPrice.display(input, prefix)
		},
		//------------------------------ UPDATE ------------------------------//
		editStart(){
			var editForm ={
				Password: "",
				"Old Email": myFB.auth.currentUser.email,
				"New Email": "",
			};
			delete editForm[".key"];
			var response = myInput.editMain(editForm, itemTemplate);
			this.errorMsg = response.errorMsg;
			this.editForm = response.output;
			this.editing = true;
		},
		editSubmit(){
			var item, response;
			var allowAdd = true;
			var checkFun = itemTemplate, editForm = myCopier.copy(this.editForm);
			response = myInput.checkMain(editForm, checkFun);
			this.errorMsg = response.errorMsg;
			if (response.error){
				allowAdd = false;
			}
			if (allowAdd){
				myNotify.loading();
				myFB.auth.signInWithEmailAndPassword(editForm["Old Email"], editForm["Password"]).then(user=>{
					myFB.auth.currentUser.updateEmail(editForm["New Email"]).then(r=>{
						myNotify.loadStop();
						myNotify.toast("Email updated!")
						myFB.updateDoc(dbPath, {Email: editForm["New Email"]}, docID, this)
						this.cancel();
					}).catch(e=>{
						myNotify.loadStop();
						console.log(e.message);
						this.errorMsg["New Email"] = e.message;
					})
				}).catch(e=>{
					myNotify.loadStop();
					console.log(e.message);
					this.errorMsg["Password"] = "Wrong password";
				})
			}
		},
		//----------------------------- BACK -----------------------------//
		cancel(){
			this.editing = false;
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/Profile/UpdateEmail.vue